/**
 * サイドメニューの表示モード（カスタマー画面のみで利用する）
 * - 常時表示
 * - 切り替え表示
 */
export const SideMenuDisplayMode = {
  ALWAYS: 'always',
  SWITCH: 'switch',
} as const

export type SideMenuDisplayMode =
  (typeof SideMenuDisplayMode)[keyof typeof SideMenuDisplayMode]
